import { useEffect, useRef, useState } from 'react'
import { Icon } from '../Brand'
import { getConfig } from '../../lib/api'
import { loadSession, saveSession } from '../../lib/sessionStore'
import AgentRail from './AgentRail'
import AgentThread from './AgentThread'

// The employee-facing shell: a rail of departmental agents on the left and the
// active agent's threaded conversation in the center. Each agent keeps its own
// thread (isolated history + stable sessionId) via the session store.
export default function UserWorkspace({ user = null, onLogout = () => {} }) {
  const [agents, setAgents] = useState([])
  const [active, setActive] = useState(null)
  const sessionRef = useRef(loadSession(user?.user_id))
  const persist = () => saveSession(user?.user_id, sessionRef.current)

  useEffect(() => {
    let cancelled = false
    getConfig()
      .then((d) => {
        if (cancelled || !d?.agents) return
        const list = d.agents.filter((a) => a.enabled !== false)
        setAgents(list)
        setActive((prev) => prev || list[0]?.name || null)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  const activeAgent = agents.find((a) => a.name === active)

  return (
    <div className="ws">
      <AgentRail
        agents={agents}
        activeName={active}
        onSelect={setActive}
        user={user}
        onLogout={onLogout}
      />
      <main className="ws-main">
        {activeAgent ? (
          <AgentThread
            key={activeAgent.name}
            agent={activeAgent}
            user={user}
            session={sessionRef.current}
            onPersist={persist}
          />
        ) : (
          <div className="chat-empty" style={{ margin: 'auto' }}>
            <div className="cs-ic"><Icon name="forum" /></div>
            <p>Loading your agents…</p>
          </div>
        )}
      </main>
    </div>
  )
}
